function isCompleted(formData: any, registrationData: any) {
  if (formData.field_Title.required && registrationData.user.title == "") {
    return false;
  }
  if (
    formData.field_LastName.required &&
    registrationData.user.lastName == ""
  ) {
    return false;
  }
  if (
    formData.field_FirstName.required &&
    registrationData.user.firstName == ""
  ) {
    return false;
  }
  if (
    formData.field_ProfessionSpecialite.required &&
    registrationData.user.idProfession == null
  ) {
    return false;
  }
  if (formData.field_Mail.required && registrationData.user.email == "") {
    return false;
  }
  if (
    formData.field_ConfirmMail.required &&
    registrationData.user.confirmMail == ""
  ) {
    return false;
  }
  if (
    formData.field_NationalId.required &&
    registrationData.user.nationalId == ""
  ) {
    return false;
  }
  if (formData.field_Phone.required && registrationData.user.phone == "") {
    return false;
  }
  if (
    formData.field_MobilePhone.required &&
    registrationData.user.mobilePhone == ""
  ) {
    return false;
  }
  if (formData.field_Comment.required && registrationData.user.comment == "") {
    return false;
  }
  if (formData.field_Login.required && registrationData.user.login == "") {
    return false;
  }
  if (
    formData.field_Password.required &&
    registrationData.user.password == ""
  ) {
    return false;
  }
  if (
    formData.field_ConfirmPassword.required &&
    registrationData.user.confirmPassword == ""
  ) {
    return false;
  }
  for (const addField of formData.additionalFields) {
    if (
      addField.visible &&
      addField.required &&
      registrationData.user.additionalFields[addField.id] == ""
    ) {
      return false;
    }
  }
  for (const attField of formData.attachmentFields) {
    if (
      attField.visible &&
      attField.required &&
      registrationData.user.attachmentFields[attField.id] == null
    ) {
      return false;
    }
  }
  if (
    formData.checkbox_ValidData.required &&
    !registrationData.user.validData
  ) {
    return false;
  }
  if (formData.checkbox_CGU.required && !registrationData.user.CGU) {
    return false;
  }
  if (
    formData.checkbox_Newsletter.required &&
    !registrationData.user.newsletter
  ) {
    return false;
  }
  for (const addCheckbox of formData.additionalCheckboxes) {
    if (
      addCheckbox.visible &&
      addCheckbox.checkboxFormType.isActive &&
      addCheckbox.required &&
      !registrationData.user.additionalCheckboxes[addCheckbox.id]
    ) {
      return false;
    }
  }

  return true;
}

export const FormService = {
  isCompleted
};
